import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

import Widget from "./Widgets";
import Widgets2 from "./Widgets2";
import Section from "./Section";
import { getUserRole } from "../../Components/utils/getUserRole";
import { getUserPermissions } from "../../helpers/fakebackend_helper";

const DashboardEcommerce = () => {
const navigate = useNavigate();

  const [rightColumn, setRightColumn] = useState(true);
  const [isPermissions, setIsPermissions] = useState([]);
  console.log("Permissions:", isPermissions);



  useEffect(() => {
    document.title = "FinEdge | Analytics";
  }, []);

  const user = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("authUser"));
    } catch {
      return null;
    }
  }, []);

  const role = useMemo(() => getUserRole(user), [user]);
  console.log('role', role);

  const refToken = user?.token
  const toggleRightColumn = () => {
    setRightColumn((prev) => !prev);
  };

  // ✅ Admin quick access cards
  const adminCards = [
    {
      title: "Advisor Central",
      bg: "secondary",
      url: `https://crm.finedge.in?refToken=${refToken}&from=dashboard`,
      status: 'Active'
    },
    {
      title: "Module 1",
      bg: "success",
      url: `https://crm.finedge.in?refToken=${refToken}`,
      status: 'Active'
    },
    {
      title: "Product Management",
      bg: "danger",
      url: `https://ops.finedge.in?refToken=${refToken}`,
      status: 'Active'

    },
    {
      title: "Operation Panel",
      bg: "info",
      url: `https://ops.finedge.in?refToken=${refToken}`,
      status: 'Active'

    },
    {
      title: "Module 2",
      bg: "warning",
      url: `https://crm.finedge.in/management-console/todays-performance?refToken=${refToken}`,
      status: 'Active'

    },
    {
      title: "Module 3",
      bg: "secondary",
      url: `https://crm.finedge.in/management-console/todays-performance?refToken=${refToken}`,
      status: 'Active'

    },
    // {
    //   title: "Customer Relationship Management",
    //   bg: "info",
    //   url: `https://crm.finedge.in/management-console/todays-performance?refToken=${refToken}`,
    //   status: 'Active'

    // },
  ];


  useEffect(() => {
    fetchPermissions();

  }, [])

  const fetchPermissions = async () => {
    try {
      const response = await getUserPermissions();
      setIsPermissions(Array.isArray(response?.permissions) ? response.permissions : []);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setIsPermissions([]);
    }
  };
  const allPermissions =
  user?.permissions?.flatMap(item => item.permissions || []) || [];


const handleCardClick = (url) => {
  if (!url) return;
  
  
  const isInternal = url.startsWith("/");

  if (isInternal) {
   
    console.log("t-1",isInternal, url);
  
      navigate(`${url}`); // same tab
  } else {

     console.log(isInternal, url);
    const finalUrl = url.startsWith("http") ? `${url}?refToken=${refToken}&from=dashboard` : `https://${url}?refToken=${refToken}&from=dashboard`;
    window.open(finalUrl, "_blank", "noopener,noreferrer"); // new tab
    
  }
};

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col>
            <div className="h-100">
              <Section rightClickBtn={toggleRightColumn} user={user} />

              {/* ADMIN */}
              
              {allPermissions.length>0  && (
                <Row >
                  {user?.permissions?.[0]?.permissions?.map((perm, index) => {
                    const matchedCard = isPermissions?.find(
                      (admin) => admin._id === perm._id
                    );

                    console.log('matchedCard', matchedCard);

                    if (!matchedCard) return null; // skip if no match

                    return (
                      <Col md="4" key={index} className="mb-3">
                       <div
  onClick={() => handleCardClick(matchedCard.url)}
  className="text-decoration-none cursor-pointer"
>
  <Card className="ribbon-box order shadow-lg h-100 hover-shadow">
    <CardBody
      className={`bg-${matchedCard.bg}-subtle d-flex align-items-center justify-content-center`}
    >
      <span className={`ribbon-three ribbon-three-${matchedCard.bg}`}>
        <span>{matchedCard.status}</span>
      </span>

      <h5 className="fs-22 py-3 text-center mb-0 text-dark">
        {matchedCard.label}
      </h5>
    </CardBody>
  </Card>
</div>
                      </Col>
                    );
                  })}
                </Row>
              )}

              {/* SUPERADMIN */}
              {role === "SUPER_ADMIN" && (
                <Row>
                  <Widget />
                </Row>
              )}

              {/* TEAM */}
              {(role === "TEAM") && (
                <Row>
                  <Widgets2 />
                </Row>
              )}


            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DashboardEcommerce;
